import { lazy, Suspense } from 'react';
import type { AssetDefinition } from '../types';

const AssetThumbnail = lazy(() => import('./AssetThumbnail').then((module) => ({ default: module.AssetThumbnail })));

export function LazyAssetThumbnail({ asset, className = '' }: { asset: AssetDefinition; className?: string }) {
  return (
    <Suspense fallback={<span className={`asset-thumbnail-3d asset-thumbnail-loading ${className}`} aria-hidden="true" />}>
      <AssetThumbnail asset={asset} className={className} />
    </Suspense>
  );
}
